<template>
  <section class="py-5"> <!-- Remove container class -->
    <div class="container"> <!-- Add inner container -->
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="tagline mb-3">Optimiza tu tiempo, impulsa tu consultorio</div>
          <h1 class="hero-headline mb-4">
            Expediente Clínico Electrónico<br>
            <span style="color:#02eebe;font-weight:700;">Inteligente</span> y<br>
            <span style="color:#02eebe;font-weight:700;">Confiable</span> para<br>
            Médicos en México
          </h1>
          <p>
            "Transforma tu <strong>práctica médica independiente</strong> con Medicynia. Nuestro <strong>sistema de Expediente Clínico Electrónico</strong> te permite <strong>gestionar pacientes de forma ágil, generar recetas médicas digitales</strong> y <strong>cumplir con todos los requisitos de la NOM-004-SSA3-2012</strong> sin complicaciones."
          </p>
          <p class="mt-4">
            <router-link to="/signup" class="btn btn-primary me-2 hero-btn">Empieza gratis ahora</router-link>
            <a href="#features" @click.prevent="scrollToFeatures" class="btn btn-secondary hero-btn">Ver Características</a>
          </p>
        </div>
        <div class="col-lg-5 d-none d-lg-block hero-image-container">
          <!-- Add the image here -->
          <img src="@/assets/heroElement.webp" alt="Medicynia Dashboard Preview" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  methods: {
    scrollToFeatures() {
      const featuresSection = document.getElementById('features');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
/* Import Bootstrap Icons if not already globally available */
/* @import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"); */

section {
  /* Background applied here, now spans full width */
  background: linear-gradient(1turn, #d5fff69e, transparent);
  /* py-5 class handles padding, remove explicit padding if desired */
  /* padding-top: 5rem; */
  /* padding-bottom: 5rem; */
}

.tagline {
  display: inline-block;
  padding: 0.3rem 0.8rem;
  background-color: #fffacd; /* Light yellow, similar to image */
  border: 1px solid #f0e68c; /* Darker yellow border */
  border-radius: 8px;
  font-weight: 500;
  color: #333;
  /* Add line connecting effect if desired */
}

.hero-headline {
  font-size: 3.5rem; /* Larger font size */
  font-weight: 700; /* Bolder */
  line-height: 1.2;
  color: #212529; /* Dark color */
}

.feature-list li {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: #555;
}

.feature-list i {
  color: #6f42c1; /* Purple color for checkmarks, adjust as needed */
}

.hero-btn {
  padding: 0.8rem 1.8rem;
  font-size: 1rem;
  border-radius: 8px; /* Rounded corners */
  font-weight: 500;
}

/* Adjust button colors if needed to match the image */
.btn-primary {
  background-color: #6f42c1; /* Purple */
  border-color: #6f42c1;
}
.btn-primary:hover {
  background-color: #5a3d9a;
  border-color: #5a3d9a;
}

.btn-secondary {
   background-color: #e9ecef; /* Light grey */
   border-color: #ced4da;
   color: #333;
}
.btn-secondary:hover {
   background-color: #ced4da;
   border-color: #adb5bd;
}

/* Define the floating animation */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px); /* Move up */
  }
  100% {
    transform: translateY(0px);
  }
}

.hero-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px; /* Optional: adds rounded corners */
  /* box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); */ /* Shadow is now part of the animation */
  /* Apply the animation */
  animation-name: float;
  animation-duration: 3s; /* Adjust duration for speed */
  animation-timing-function: ease-in-out; /* Smooth transition */
  animation-iteration-count: infinite; /* Loop forever */
}

/* Responsive adjustments */
@media (max-width: 991.98px) {
  .hero-headline {
    font-size: 2.8rem;
  }
  .tagline {
     margin-left: auto;
     margin-right: auto;
  }
   .feature-list {
     display: inline-block;
     text-align: left;
   }
}

@media (max-width: 767.98px) {
  .hero-headline {
    font-size: 2.2rem;
  }
  .hero-btn {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 0.5rem;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
   .btn-primary.me-2 {
     margin-right: auto !important; /* Center button */
   }
}
</style>
